import { AfterContentChecked, ChangeDetectorRef, Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { GlobalState } from './global.state';
import { BaThemePreloader, BaThemeSpinner } from './shared/services';
import { BaseComponent } from 'app/shared/infrastructure/base.component'; // leaf import - do not revert to the barrel (app/shared/infrastructure), breaks ng test (circular dependency)
import { LoaderService } from 'app/loader/_services/loader.service';
import { AuthService } from './shared/services/auth/auth.service';
import { SessionWarningModalComponent } from './shared/components/session-warning-modal/session-warning-modal.component';
import { SessionManagementService } from './shared/services/session/session-management.service';

/*
 * App Component
 * Top Level Component
 */
@Component({
    selector: 'app',
    styleUrls: ['./app.component.scss'],
    templateUrl: './app.component.html',
})
export class App extends BaseComponent implements AfterContentChecked, OnInit, OnDestroy {
    @ViewChild(SessionWarningModalComponent) sessionWarningModal: SessionWarningModalComponent;

    isMenuCollapsed: boolean = false;

    constructor(
        private _state: GlobalState,
        private ref: ChangeDetectorRef,
        public _loaderService: LoaderService,
        private _spinner: BaThemeSpinner,
        public authService: AuthService,
        public sessionManagement: SessionManagementService) {
        super();
        this._state.subscribe('menu.isCollapsed', (isCollapsed) => {
            this.isMenuCollapsed = isCollapsed;
        });
    }

    ngOnInit(): void {
        if (this.authService.user) {
            this.sessionManagement.initializeForUser();
        }

        this.authService.userChanged.subscribe(user => {
            if (user) {
                this.sessionManagement.initializeForUser();
            } else {
                this.sessionManagement.stopSessionManagement();
            }
        });
    }

    ngAfterContentChecked() {
        this.ref.detectChanges();
    }

    get showWarningModal(): boolean {
        return this.sessionManagement.showWarningModal;
    }

    get remainingSeconds(): number {
        return this.sessionManagement.remainingSeconds;
    }

    ngAfterViewInit(): void {
        BaThemePreloader.load().then(() => {
            this._spinner.hide();
        });

        setInterval(() => {
            if (this.sessionWarningModal && this.remainingSeconds > 0) {
                this.sessionWarningModal.updateCountdown(this.remainingSeconds);
            }
        }, 100);
    }
    public onStayLoggedIn(): void {
        this.sessionManagement.onStayLoggedIn();
    }

    public onLogoutNow(): void {
        this.sessionManagement.onLogoutNow();
    }

    ngOnDestroy(): void {
        this.sessionManagement.ngOnDestroy();
    }
}